module.exports = __webpack_public_path__ + "media/images/logo_cardif-e349e5f3.png";